import { API_BASE_URL } from '../constants/appConstants';
import { authenticatedRequest } from './authService';

const ACCOUNT_BASE_URL = `${API_BASE_URL}/accounts`;


export const getUserList = async () => {
  try {
    const response = await authenticatedRequest(`${ACCOUNT_BASE_URL}/list/`);
    // const data = await response.json();
    return response;
  } catch (error) {
    // Always throw a safe error message
    let errMsg = "Unknown error";
    if (error?.response?.data) {
      errMsg = error.response.data;
    } else if (error?.message) {
      errMsg = error.message;
    }
    throw errMsg;
  }
};


// Get current user's profile
export const getCurrentUserProfile = async () => {
  const response = await authenticatedRequest(`${ACCOUNT_BASE_URL}/me/`, {
    method: 'GET',
  });
  // if (!response.ok) throw new Error('Failed to fetch user profile');
  return response;
};

// Update current user's profile
export const updateCurrentUserProfile = async (profileData) => {
  const response = await authenticatedRequest(`${ACCOUNT_BASE_URL}/me/`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profileData)
  });
  // if (!response.ok) throw new Error('Failed to update user profile');
  return response;
};




